import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useFacilityLessonPatronAccess_facility$key } from "./__generated__/useFacilityLessonPatronAccess_facility.graphql";

export const useFacilityLessonPatronAccess = (
  facilityRef: useFacilityLessonPatronAccess_facility$key | null
) => {
  const facility = useFragment(
    useFacilityLessonPatronAccessFragmentString,
    facilityRef
  );
  const patronAccess = facility?.club?.supportsPublic
    ? facility?.publicLessonsPermissionSet?.patronAccess || "NONE"
    : facility?.privateLessonsPermissionSet?.patronAccess || "NONE";

  return patronAccess;
};

const useFacilityLessonPatronAccessFragmentString = graphql`
  fragment useFacilityLessonPatronAccess_facility on Facility {
    club {
      supportsPublic
    }
    publicLessonsPermissionSet {
      patronAccess
    }
    privateLessonsPermissionSet {
      patronAccess
    }
  }
`;
